import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { StudentFormModalComponent } from '../../../../components/personnel-component/student-components/student-form-modal/student-form-modal.component';
import { StudentApiServiceService } from '../student-api-service.service';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { catchError, finalize, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { ConfomerService } from '../../../../providers/confomer/confomer.service';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { PaginationComponent } from "../../../../components/pagination/pagination.component";
import { CascadingSelectServiceService } from '../../../services/cascading-select-service.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoaderComponent } from "../../../../providers/loader.component";
import { FilterBaseAccessService } from '../../../../auth/filterbase-access';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { exportToCsv, exportToExcel, exportToPdf, parseCsvToObjects, type ExportColumn } from '../../utils/personnel-import-export';
@Component({
  selector: 'app-student-list',
  standalone: true,
  imports: [RouterModule, StudentFormModalComponent, CommonModule, PaginationComponent, ReactiveFormsModule, LoaderComponent],
  templateUrl: './student-list.component.html',
  styleUrl: './student-list.component.css'
})
export class StudentListComponent {

  
  formType: 'new' | 'edit' = 'new'
  studentId: number | string | null = null
  isMoaldalOpen = false
  studenList: any[] = []
  paginationData: any = {}
  currentPage: any = ''

  departments: any[] = [];
  classes: any[] = [];
  batches: any[] = [];
  academicYear$!: Observable<any>;
  academicYears: any[] = [];
  academicYearById = new Map<string | number, string>();

  academicEntries$!: Observable<any>;
file_import_export: boolean = false;
import_file: boolean = false;
export_file: boolean = false;
date_filter: boolean = false;
  isFilterApplied: boolean = false;
  serachFiledForm!: FormGroup
  isFetching: boolean = false;
    create_student: boolean = false;
  student_list: boolean = false;
  view_student: boolean = false;
 
  actions: boolean = false;
 
  course_filter: boolean = false;
    student_chat: boolean = false;
    certificates: boolean = false;
    edit_student: boolean = false
    delete_student: boolean = false;
    performance: boolean = false;
    private readonly exportColumns: ExportColumn[] = [
      { key: 'first_name', label: 'Student Name' },
      { key: 'mobile', label: 'Mobile' },
      { key: 'email_id', label: 'Email' },
      { key: 'academic_year', label: 'Academic Year', value: row => this.getAcademicYearLabel(row?.admission?.academic_year) },
      { key: 'is_active', label: 'Status', value: row => (row?.is_active ? 'Active' : 'Inactive') }
    ];
  
  selectedStudentKeys: Set<string | number> = new Set();
    

  constructor(private studentApiService: StudentApiServiceService, private toasterService: ToasterService, private conformer: ConfomerService, private store: Store,
    private access: FilterBaseAccessService,
    public cascadService: CascadingSelectServiceService, private fb: FormBuilder, private router: Router
  ) {

    this.academicYear$ = this.cascadService.academicYear$;
    this.academicEntries$ = this.cascadService.academicEntries$
    this.academicEntries$.subscribe((data: any) => this.departments = data.data)
    this.academicYear$.subscribe((res: any) => {
      const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
      this.academicYears = list;
      this.academicYearById.clear();
      list.forEach((year: any) => {
        const label = year?.alias || year?.name || year?.academic_year || year?.title;
        if (year?.id != null && label) {
          this.academicYearById.set(year.id, label);
        }
      });
    });
 this.create_student =
      this.access.checkaccessforfiltersandactions('create student');
      this.student_list = this.access.checkaccessforfiltersandactions('student list');
      this.view_student = this.access.checkaccessforfiltersandactions('view student');
      this.file_import_export = this.access.checkaccessforfiltersandactions('file import export');
      this.import_file = this.access.checkaccessforfiltersandactions('import file');
      this.export_file = this.access.checkaccessforfiltersandactions('export file');
      this.actions = this.access.checkaccessforfiltersandactions('actions');
      this.date_filter = this.access.checkaccessforfiltersandactions('date filter');
      
      this.course_filter = this.access.checkaccessforfiltersandactions('course filter');
      this.student_chat = this.access.checkaccessforfiltersandactions('student_chat');
      this.certificates = this.access.checkaccessforfiltersandactions('certificates');
      this.edit_student = this.access.checkaccessforfiltersandactions('edit student');
      this.delete_student = this.access.checkaccessforfiltersandactions('delete student');
      this.performance = this.access.checkaccessforfiltersandactions('performance');
      
      
      
  }

  ngOnInit() {
    this.serachFiledForm = this.fb.group({
      search: [''],
      department: [null],
      class: [{ value: null, disabled: true }],
      batch: [{ value: null, disabled: true }],
      status: [null],
      academic_year: [null]
    })
    this.serachFiledForm.get('search')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = null;
      this.getData(null, this.serachFiledForm.value);
      this.isFilterApplied = true;
    });
    this.getData()
  }

  getData(element?: any, params?: any) {
    this.isFetching = true;
    this.studenList = []
    this.clearSelection();
    this.studentApiService.getStudentList(this.currentPage, params)
      .pipe(finalize(() => { this.isFetching = false; }))
      .subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.studenList = res?.data ?? [];
            this.paginationData = res?.pagination ?? {};
            this.clearSelection();
          }
          if (element) {
            if (Array.isArray(element)) {
              element.forEach(item => item.classList.toggle('hidden'));
            } else {
              element.classList.toggle('hidden');
            }
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      })
  }

  async deleteStudent(id: any) {
    if (!id) {
      return
    }

    const confirmer = await this.conformer.Open('Delete Student Profile!', 'Are you sure you want to delete this student profile')
    if (confirmer) {
      this.studentApiService.deleteStudentProfileDetails(id).pipe(
        finalize(() => {
          this.getData()
        })
      ).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Student deleted successfully');
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      })
    }

  }
openChat(id: number | string) {
    this.router.navigate(['/chats'], { queryParams: { type: 'student', id } });
  }
  toggleStatus(event: any, studentId: number) {
    const value = event.target.checked ? 'active' : 'inactive';
    let loader = document.getElementById(`status_loader_${studentId}`) as HTMLSpanElement;
    let badge = document.getElementById(`status_message_${studentId}`) as HTMLDivElement;
    loader.classList.remove('hidden');
    badge.classList.add('hidden');
    this.studentApiService.setStudentActiveStatus(studentId, value).pipe(
      finalize(() => {
        this.getData([badge, loader], this.serachFiledForm.value);
      })
    ).subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          this.toasterService.setToaster('success', 'Success', res.message ?? 'Status updated successfully');
        }
      },
      error: (err) => {
        console.error('HTTP error:', err);
      }
    })
  }

  showStudentFormModal(type: 'new' | 'edit', studentId?: number | string | null) {
    this.formType = type
    this.studentId = studentId || null
    setTimeout(() => {
      this.isMoaldalOpen = true;
    }, 100);
  }

  emitedData(data: any) {
    console.log(data)
    this.isMoaldalOpen = false;
    this.studentId = null;
    this.formType = 'new';
    this.currentPage = null;
    this.getData(null, this.serachFiledForm?.value);
  }

  pageChange(page: number) {
    this.currentPage = page
    this.getData(null, this.serachFiledForm.value);
  }

  private loadStudentExportRows(params?: any) {
    return this.studentApiService.getStudentList(1, params).pipe(
      switchMap((res: any) => {
        const rows = Array.isArray(res?.data) ? res.data : [];
        const pagination = res?.pagination ?? {};
        const lastPage = Number(pagination?.last_page ?? 0) || ((Number(pagination?.total ?? 0) > 0 && Number(pagination?.per_page ?? 0) > 0)
          ? Math.ceil(Number(pagination.total) / Number(pagination.per_page))
          : 0);
        if (lastPage <= 1) {
          return of(rows);
        }
        const pageRequests = [];
        for (let page = 2; page <= lastPage; page += 1) {
          pageRequests.push(
            this.studentApiService.getStudentList(page, params).pipe(
              map((pageRes: any) => Array.isArray(pageRes?.data) ? pageRes.data : []),
              catchError(() => of([]))
            )
          );
        }
        return forkJoin(pageRequests).pipe(
          map((pages: any[]) => rows.concat(...pages))
        );
      })
    );
  }

  get selectedCount(): number {
    return this.selectedStudentKeys.size;
  }

  getStudentKey(student: any, index: number): string | number {
    return student?.id ?? student?.student_id ?? student?.user_id ?? `idx-${index}`;
  }

  isSelected(student: any, index: number): boolean {
    const key = this.getStudentKey(student, index);
    return this.selectedStudentKeys.has(key);
  }

  toggleRowSelection(event: Event, student: any, index: number) {
    const target = event.target as HTMLInputElement;
    const key = this.getStudentKey(student, index);
    if (target.checked) {
      this.selectedStudentKeys.add(key);
    } else {
      this.selectedStudentKeys.delete(key);
    }
  }

  toggleSelectAll(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      this.studenList.forEach((student, index) => {
        this.selectedStudentKeys.add(this.getStudentKey(student, index));
      });
    } else {
      this.clearSelection();
    }
  }

  isAllSelected(): boolean {
    return this.studenList.length > 0 && this.selectedStudentKeys.size === this.studenList.length;
  }

  isSomeSelected(): boolean {
    return this.selectedStudentKeys.size > 0 && this.selectedStudentKeys.size < this.studenList.length;
  }

  clearSelection() {
    this.selectedStudentKeys.clear();
  }

  getAcademicYearLabel(value: any): string {
    if (!value) {
      return '-';
    }
    if (typeof value === 'object') {
      return value?.alias || value?.name || value?.academic_year || value?.title || '-';
    }
    const mapped = this.academicYearById.get(Number(value)) || this.academicYearById.get(String(value));
    return mapped || '-';
  }



  setFields(event: Event, type: 'department' | 'class') {
    const target = event.target as HTMLSelectElement;
    const value = target?.value;

    if (!value || value === 'null') {
      if (type === 'department') {
        this.cascadService.reset();
        this.serachFiledForm.patchValue({ class: null, batch: null });
        this.serachFiledForm.get('class')?.disable();
        this.serachFiledForm.get('batch')?.disable();
        this.classes = [];
        this.batches = [];
      } else if (type === 'class') {
        this.cascadService.reset();
        this.serachFiledForm.patchValue({ batch: null });
        this.serachFiledForm.get('batch')?.disable();
        this.batches = [];
      }
      return;
    }

    const numericValue = +value;

    if (type === 'department') {
      this.cascadService.setDepartment(value);
      const matched = this.departments.find(d => d.id === numericValue);
      this.classes = matched?.classes || [];
      this.batches = [];

      this.serachFiledForm.patchValue({ class: null, batch: null });
      this.serachFiledForm.get('class')?.enable();
      this.serachFiledForm.get('batch')?.disable();
    }

    if (type === 'class') {
      this.cascadService.setClass(value);
      const matched = this.classes.find(c => c.id === numericValue);
      this.batches = matched?.batches || [];

      this.serachFiledForm.patchValue({ batch: null });
      this.serachFiledForm.get('batch')?.enable();
    }
  }



  onSearchSubmit() {
    this.currentPage = null
    this.getData(null, this.serachFiledForm.value);
    this.isFilterApplied = true;
  }

  resetSearchForm() {
    this.serachFiledForm.reset();
    this.cascadService.reset();
    this.currentPage = null;
    this.getData();
    this.serachFiledForm.patchValue({
      class: null,
      batch: null
    })
    setTimeout(() => {
      this.isFilterApplied = false;
    }, 0);
  }

  ngOnDestroy() {
    this.resetSearchForm();
  }

  exportData(type: 'csv' | 'excel' | 'pdf') {
    const queryParams = this.serachFiledForm?.value ?? {};
    this.loadStudentExportRows(queryParams).subscribe((rows: any[]) => {
      if (!rows?.length) {
        this.toasterService.setToaster('error', 'Export', 'No student data available to export.');
        return;
      }
      const filenameBase = 'student-list';
      if (type === 'pdf') {
        exportToPdf(rows, this.exportColumns, 'Student List');
        return;
      }
      if (type === 'excel') {
        exportToExcel(rows, this.exportColumns, `${filenameBase}.xls`);
        return;
      }
      exportToCsv(rows, this.exportColumns, `${filenameBase}.csv`);
    });
  }

  handleImportFile(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const rows = parseCsvToObjects(String(reader.result ?? ''));
      if (!rows.length) {
        this.toasterService.setToaster('error', 'Import', 'No valid rows found in CSV.');
        return;
      }
      const requests = rows.map(row =>
        this.studentApiService.createStudentProfileDetails(row).pipe(
          map(() => ({ ok: true })),
          catchError(() => of({ ok: false }))
        )
      );
      forkJoin(requests).subscribe(results => {
        const successCount = results.filter(result => result.ok).length;
        const failedCount = results.length - successCount;
        if (successCount) {
          this.currentPage = null;
          this.getData(null, this.serachFiledForm?.value);
        }
        if (failedCount) {
          this.toasterService.setToaster('warning', 'Import', `${successCount} imported, ${failedCount} failed.`);
        } else {
          this.toasterService.setToaster('success', 'Import', `${successCount} students imported successfully.`);
        }
      });
    };
    reader.readAsText(file);
    input.value = '';
  }



}